import { render, staticRenderFns } from "./LSAAudit.vue?vue&type=template&id=20ffc082"
import script from "./LSAAudit.vue?vue&type=script&lang=js"
export * from "./LSAAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports